import { SVGProps } from "react";

const STIRss = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="RSS" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#f80" /><circle cx={145} cy={367} r={35} fill="#fff" /><path fill="none" stroke="#fff" strokeWidth={60} d="M109 241c89 0 162 73 162 162m114 0c0-152-124-276-276-276" /></svg>;

export { STIRss };